import axios from 'axios';

export function updateContact(data) {
  return axios.post(`/api/?entity=contacts&action=update`, data).then(response => response.data);
}
